export enum PropertySummaryChart {
  Pricing = 'Pricing',
  Insights = 'Insights',
  PriceHistory = 'PriceHistory',
  Occupancy = 'Occupancy',
  AvailabilityForecast = 'AvailabilityForecast',
  LeaseExpirations = 'LeaseExpirations',
  Renewals = 'Renewals',
  UpcomingRenewals = 'UpcomingRenewals',
  Demand = 'Demand',
  Conversion = 'Conversion',
  MarketPosition = 'MarketPosition',
  AverageLeaseTradeOut = 'AverageLeaseTradeOut',
  Rent = 'Rent',
  RevenuePerSqFt = 'RevenuePerSqFt',
  Units = 'Units',
  Weather = 'Weather',
  LeadSources = 'LeadSources',
  GoogleReviews = 'GoogleReviews',
}
